// Module
var code = `<template>
  <require from="./breakdown-per-dimension-widget.scss"></require>

  <div class="breakdown-per-dimension-widget breakdown-per-dimension-widget-\${id}">
    <!-- beautify ignore:start -->
    <style>
      .breakdown-per-dimension-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .breakdown-per-dimension-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-caption-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-caption-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <table show.bind="!loading && !error" class="breakdown-per-dimension-widget__table">
      <thead>
        <tr>
          <th style="text-align: left">\${categoryType}</th>
          <th class="mdc-data-table__cell--numeric">\${fieldName}</th>
          <th class="mdc-data-table__cell--numeric">%</th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="g of instrumentGroups">
          <td>\${g.group}</td>
          <td class="mdc-data-table__cell--numeric">\${g[aggregatedField] | numericFormatter:precision}</td>
          <td class="mdc-data-table__cell--numeric">\${g.percentage | numericFormatter:precision}</td>
        </tr>
        <tr class="breakdown-per-dimension-widget__totals">
          <td>Total:</td>
          <td class="mdc-data-table__cell--numeric">\${totals | numericFormatter:precision}</td>
          <td class="mdc-data-table__cell--numeric">\${100 | numericFormatter:precision}</td>
        </tr>
      </tbody>
    </table>
    <message if.bind="error" icon="error" colour="mdc-theme--error" class="breakdown-per-dimension-widget__error">
      \${error.message}</message>

  </div>
</template>
`;
// Exports
export default code;